export const FormFieldList = {
  parts: ['FormFieldList', 'FormFieldListItem', 'FormFieldListItemLabel', 'FormFieldListItemField'],
  baseStyle: {},
  variants: {
    horizontal: {
      FormFieldListItem: {
        flexDirection: 'row',
        alignItems: 'center'
      },
      FormFieldListItemLabel: {
        my: 0,
        flex: 1,
        textAlign: 'end'
      },
      FormFieldListItemField: {
        flex: 3
      }
    },
    vertical: {
      FormFieldListItem: {
        flexDirection: 'column'
      },
      FormFieldListItemLabel: {
        textAlign: 'start'
      }
    }
  },
  defaultProps: {
    variant: 'horizontal'
  }
}

export default FormFieldList
